import PhoneChangePopup from 'Common/PhoneChangePopup';

export default {
  data: () => ({
    showPhoneChangePopup: false,
  }),
  components: {
    PhoneChangePopup,
  },
  methods: {
    openPhoneChangePopup() {
      this.showPhoneChangePopup = true;
    },
    closePhoneChangePopup() {
      this.showPhoneChangePopup = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/phoneChangePopupLogic.js